import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useSnackbar } from 'notistack';
import { CompaniesService } from 'api';
import {
  COMPANY_CAP_IQ_OVERVIEW_DEFAULT_ERROR_MESSAGE,
  COMPANY_CAP_IQ_OVERVIEW_QUERY_KEY,
} from 'common/constants/services/companies';

const getCompanyCapIQOverview = async (companyId: number) => CompaniesService.apiCompaniesCapIqOverviewRead(companyId);

const useGetCompanyCapIQOverview = (companyId: number | undefined) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isFetching, isLoading, isError } = useQuery({
    enabled: !isNil(companyId),
    queryFn: () => getCompanyCapIQOverview(companyId as number),
    queryKey: [COMPANY_CAP_IQ_OVERVIEW_QUERY_KEY, companyId],
    retry: false,
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(COMPANY_CAP_IQ_OVERVIEW_DEFAULT_ERROR_MESSAGE, { variant: 'error' });
    }
  }, [isError, enqueueSnackbar]);

  return { data, isFetching, isLoading, isError };
};

export default useGetCompanyCapIQOverview;
